// extracted by mini-css-extract-plugin
export default {"landscapeWrapper":"LandscapeProjectsAddRequestedSupportOrganism_landscapeWrapper__g6PLN"};